
export default function ValuesSection() {
  const values = [
    {
      icon: "ri-heart-line",
      title: "Passion",
      description: "We instill a genuine love for soccer that extends beyond the field, creating lifelong enthusiasts of the beautiful game."
    },
    {
      icon: "ri-team-line",
      title: "Teamwork",
      description: "Building strong team bonds and teaching players to work together towards common goals, both in soccer and in life."
    },
    {
      icon: "ri-star-line",
      title: "Excellence",
      description: "Striving for the highest standards in training, coaching, and personal development for every player."
    },
    {
      icon: "ri-shield-check-line",
      title: "Integrity",
      description: "Teaching honesty, respect, and fair play as fundamental values that shape character on and off the field."
    },
    {
      icon: "ri-lightbulb-line",
      title: "Growth",
      description: "Fostering continuous improvement and learning, helping each player reach their individual potential."
    },
    {
      icon: "ri-community-line",
      title: "Community",
      description: "Building a supportive soccer family that celebrates achievements and supports each other through challenges."
    }
  ];

  return (
    <section className="py-16 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="text-4xl font-bold text-gray-900 mb-4">Our Core Values</h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            These fundamental principles guide everything we do at NextZen Soccer Academy, shaping not just better players, but better people.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {values.map((value, index) => (
            <div key={index} className="bg-gray-50 p-8 rounded-lg text-center hover:shadow-lg transition-shadow duration-300">
              <div className="w-16 h-16 bg-purple-100 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className={`${value.icon} text-2xl text-purple-600`}></i>
              </div>
              <h3 className="text-xl font-semibold text-gray-900 mb-3">{value.title}</h3>
              <p className="text-gray-700 leading-relaxed">{value.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
